import { z } from 'zod'

export const AGENTMCP_PUBLIC_READ_CONTRACT_VERSION = '1.0.0' as const

const agentmcpToolSchema = z.object({
  name: z.string(),
  description: z.string(),
  inputSchema: z.object({
    type: z.literal('object'),
    properties: z.record(z.unknown()),
    required: z.array(z.string()).optional(),
  }).passthrough(),
}).passthrough()

export const agentmcpToolsResponseSchema = z.object({
  tools: z.array(agentmcpToolSchema),
}).passthrough()

export const agentmcpToolsChatgptResponseSchema = agentmcpToolsResponseSchema

export type AgentmcpToolsResponse = z.infer<typeof agentmcpToolsResponseSchema>
export type AgentmcpToolsChatgptResponse = z.infer<typeof agentmcpToolsChatgptResponseSchema>
